var scope_0 = require('/opt/build/repo/demo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/opt/build/repo/demo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3b6c54335596d8aa0689bb4402388682.js').default;
var scope_2 = require('/opt/build/repo/demo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/864f945385403ec0c5c4b2bab77f6c08.js').default;
var scope_3 = require('/opt/build/repo/demo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/df12e7980484a90d629c5b950a52de2f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    